import { useMemo } from "react";
import { buildGoogleMapsUrl } from "../../lib/build-google-maps-url";
import { Place } from "../../types/Place";

interface GoogleMapsLinkProps {
  place: Place;
  inline?: boolean;
  label?: string;
  icon?: boolean;
}

export const GoogleMapsLink: React.FC<GoogleMapsLinkProps> = ({
  place,
  label,
  icon,
  inline,
}) => {
  const content = useMemo(() => {
    if (icon) {
      return <i className="material-icons">map</i>;
    }
    if (label) {
      return <span>{label}</span>;
    }
    return <span>{place.name}</span>;
  }, [icon, label, place]);

  const link = (
    <a
      className="google-maps-link"
      target="_blank"
      rel="noopener noreferrer"
      href={buildGoogleMapsUrl(place.lat, place.lng)}
    >
      {content}
    </a>
  );

  if (inline) {
    return link;
  }

  return <div className="google-maps-link-wrapper">{link}</div>;
};
